// Tour Prompt Component
// Context-aware nudge card that appears on the 3rd visit to an area
// Reads from activeTourPromptId signal (no props needed)

import { h } from 'preact'
import { startTour, showTourPrompt, activeTourPromptId, markTourDismissed } from './tourState.js'
import { getTour } from './tourDefinitions.js'
import { IconX } from '../components/shared/Icons.jsx'

export default function TourPrompt() {
  if (!activeTourPromptId.value) return null

  const tour = getTour(activeTourPromptId.value)
  if (!tour) return null

  const handleStart = () => {
    const tourId = activeTourPromptId.value
    showTourPrompt.value = false
    activeTourPromptId.value = null
    startTour(tourId)
  }

  const handleDismiss = () => {
    const tourId = activeTourPromptId.value
    markTourDismissed(tourId) // Permanent dismiss -- marks tour as 'dismissed'
    showTourPrompt.value = false
    activeTourPromptId.value = null
  }

  return (
    <div className="tour-prompt">
      <div className="tour-prompt-content">
        <div className="tour-prompt-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
            <line x1="12" y1="17" x2="12.01" y2="17"/>
          </svg>
        </div>
        <div className="tour-prompt-text">
          <h4>{tour.name}</h4>
          <p>{tour.description}</p>
        </div>
        <div className="tour-prompt-actions">
          <button
            className="tour-prompt-btn tour-prompt-btn-primary"
            onClick={handleStart}
          >
            Start Tour
          </button>
          <button
            className="tour-prompt-btn tour-prompt-btn-ghost"
            onClick={handleDismiss}
            title="Dismiss (won't show again)"
          >
            <IconX size={16} />
          </button>
        </div>
      </div>
    </div>
  )
}
